import React from 'react';

import SunScroll from './SunScroll';

import './App.scss';

function App() {
  return (
    <div className="App">
      <SunScroll />
    </div>
  );
}

export default App;
